module.exports = __webpack_public_path__ + "assets/img/mtTitle-95b26fe9.png";